import { lazy } from "react";

const MapScreem = lazy(() =>
  import(/* webpackChunkName: "MapScrem"*/ "../components/mapScreem/MapScreem")
);
const Timings = lazy(() =>
  import(/* webpackChunkName: "TimingScreem"*/ "../components/timing/Timings")
);

const ScreemDriverTiming = lazy(() =>
  import(
    /* webpackChunkName: "ScreemDriverTiming"*/ "../components/driverTiming/ScreemDriverTiming"
  )
);
const Orders = lazy(() =>
  import(/* webpackChunkName: "Orders"*/ "../components/order/Orders")
);
const OrdersLegacy = lazy(() =>
  import(/* webpackChunkName: "OrdersLegacy"*/ "../components/order/OrdersLegacy")
);
const OperationMap = lazy(() =>
  import(/* webpackChunkName: "OperationMap"*/ "../components/operationMap/OperationMap")
);
const PanelLite = lazy(() =>
  import(/* webpackChunkName: "PanelLite"*/ "../components/panel-lite/PanelLite")
);
const PanelLiteLegacy = lazy(() =>
  import(/* webpackChunkName: "PanelLiteLegacy"*/ "../components/panel-lite/PanelLiteLegacy")
);
const PanelGeneral = lazy(() =>
  import(/* webpackChunkName: "PanelGeneral"*/ "../components/panel-general/PanelGeneral")
);
const DashboardSupervisor = lazy(() =>
  import(/* webpackChunkName: "DashboardSupervisor"*/ "../components/dashboard-supervisor/DashboardSupervisor")
);
const PaymentReports = lazy(() =>
  import(/* webpackChunkName: "PaymentReports"*/ "../components/payment-reports/PaymentReports")
);
const Automations = lazy(() =>
  import(/* webpackChunkName: "PanelLite"*/ "../components/automations/Automations")
);
const Drivers = lazy(() =>
  import(/* webpackChunkName: "Drivers"*/ "../components/driver/Drivers")
);
const Reclamo = lazy(() =>
  import(/* webpackChunkName: "Reclamo"*/ "../components/reclamo/Reclamo")
);
const Notification = lazy(() =>
  import(
    /* webpackChunkName: "Notification"*/ "../components/notification/Notification"
  )
);
const BotDrivers = lazy(() =>
  import(/* webpackChunkName: "BotDrivers"*/ "../components/botDrivers/BotDrivers")
);
const Analityc = lazy(() =>
  import(/* webpackChunkName: "Analityc"*/ "../components/analityc/Analityc")
);
const CalendarTiming = lazy(() =>
  import(
    /* webpackChunkName: "CalendarTiming"*/ "../components/calendarTiming/CalendarTiming"
  )
);
const TurnWeekPage = lazy(() =>
  import(
    /* webpackChunkName: "TurnWeekPage"*/ "../components/turnsWeek/TurnWeekPage"
  )
);
const TimingByDate = lazy(() =>
  import(
    /* webpackChunkName: "TimingByDate"*/ "../components/timingByDate/TimingByDate"
  )
);
const Zone = lazy(() =>
  import(/* webpackChunkName: "Zone"*/ "../components/zone/Zone")
);
const Merchant = lazy(() =>
  import(/* webpackChunkName: "Merchant"*/ "../components/merchant/Merchant")
);
const Banner = lazy(() =>
  import(/* webpackChunkName: "Banner"*/ "../components/banner-driver/Banner")
);
const Report = lazy(() =>
  import(/* webpackChunkName: "Report"*/ "../components/ExecutiveReport/Report")
);
const QuickDrop = lazy(() =>
  import(/* webpackChunkName: "QuickDrop"*/ "../components/quickdrop/QuickDrop")
);
const OrdersByHours = lazy(() =>
  import(
    /* webpackChunkName: "OrdersByHours"*/ "../components/ordersByyHours/OrdersByHours"
  )
);
const OrdersByHoursUpload = lazy(() =>
  import(
    /* webpackChunkName: "OrdersByHoursUpload"*/ "../components/ordersByyHours/OrdersByHoursUpload"
  )
);
const MerchantDetails = lazy(() =>
  import(
    /* webpackChunkName: "MerchantDetails"*/ "../components/merchantDetails/MerchatDetails"
  )
);
const Item = lazy(() =>
  import(/* webpackChunkName: "Item"*/ "../components/item/Item")
);
const OpeningHours = lazy(() =>
  import(
    /* webpackChunkName: "OpeningHours"*/ "../components/openingHours/OpeningHours"
  )
);

const Offer = lazy(() =>
  import(/* webpackChunkName: "Offer"*/ "../components/offert/Offert")
);

const Fare = lazy(() =>
  import(/* webpackChunkName: "Fare"*/ "../components/fare/Fare")
);

const FareDetail = lazy(() =>
  import(/* webpackChunkName: "Fare"*/ "../components/fareDetail/FareDetail")
);

const ProviderFare = lazy(() =>
  import(/* webpackChunkName: "ProviderFare"*/ "../components/providerFare/ProviderFare")
);

const ProviderFareDetail = lazy(() =>
  import(/* webpackChunkName: "ProviderFareDetail"*/ "../components/providerFareDetail/ProviderFareDetail")
);

const MerchantLocation = lazy(() =>
  import(
    /* webpackChunkName: "MerchantLocation"*/ "../components/merchantLocation/MerchantLocation"
  )
);

const MerchantConfig = lazy(() =>
  import(
    /* webpackChunkName: "MerchantConfig"*/ "../components/merchantConfig/MerchantConfig"
  )
);

const Coverage = lazy(() =>
  import("../components/coverage/Coverage.jsx")
);

const CoverageStatus = lazy(() =>
  import("../components/coverage/CoverageStatus.jsx")
);

const CoverageMap = lazy(() =>
  import("../components/coverage/CoverageMap.jsx")
);

const DriversWallet = lazy(() =>
  import(
    /* webpackChunkName: "Drivers"*/ "../components/driver-wallet/DriverWallet.jsx"
  )
);

const DriverOrderHistory = lazy(() =>
  import(
    /* webpackChunkName: "DriverOrderHistory"*/ "../components/driver-orders-history/DriverOrderHistory.jsx"
  )
);

const Coupons = lazy(() =>
  import(/* webpackChunkName: "Drivers"*/ "../components/coupon/Coupon.jsx")
);

const CouponsUser = lazy(() =>
  import(
    /* webpackChunkName: "Drivers"*/ "../components/coupon-users/CouponUser.jsx"
  )
);
const HeatMap = lazy(() =>
  import(
    /* webpackChunkName: "HeatMapOrders"*/ "../components/heat-map/HeatMap.jsx"
  )
);

const HeatMapQuote = lazy(() =>
  import(
    /* webpackChunkName: "HeatMapQuote"*/ "../components/heatmap-quote/HeatMapQuote.jsx"
  )
);

const MapZipCode = lazy(() =>
  import(
    /* webpackChunkName: "MapZipCode"*/ "../components/mapZipcode/MapZipCode.jsx"
  )
);

const MapZipCodeEdit = lazy(() =>
  import(
    /* webpackChunkName: "MapZipCodeEdit"*/ "../components/mapZipcode/MapZipCodeEdit.jsx"
  )
);

const FeedBack = lazy(() =>
  import(
    /* webpackChunkName: "Feedback"*/ "../components/feedback/Feedback.jsx"
  )
);

const ProductOffers = lazy(
  () =>
    import(
      /* webpackChunkName: "productOffers" */ "../components/productOffer/ProductOfferts.jsx"
    )
  //src\components\productOffer\ProductOffers.jsx
);

const MerchantsHomeApp = lazy(() =>
  import(
    /* webpackChunkName: "merchantsHomeApp" */ "../components/merchantsHomeApp/MerchantsHomeApp.jsx"
  )
);

const UploadImage = lazy(() =>
  import(
    /* webpackChunkName: "uploadImage" */ "../components/uploadImage/UploadImage.jsx"
  )
);
const MerchantVehicleType = lazy(() =>
  import(
    /* webpackChunkName: "merchantVehicleType" */ "../components/merchantVehicleType/MerchantVehicleType.jsx"
  )
);

const ControlCost = lazy(() =>
  import(
    /* webpackChunkName: "controlCost" */ "../components/controlCost/ControlCost.jsx"
  )
);

const AutoTimings = lazy(() =>
  import(
    /* webpackChunkName: "autoTimings" */ "../components/autoTimings/AutoTimings.jsx"
  )
);

const TimingKPIPage = lazy(() =>
  import(
    /* webpackChunkName: "timingKPI" */ "../components/timingKPI/TimingKPIPage.jsx"
  )
);

const DriverOrdersByHourZonePage = lazy(() =>
  import(
    /* webpackChunkName: "driverOrdersByHourZone" */ "../components/driverOrdersByHourZone/DriverOrdersByHourZonePage.jsx"
  )
);

const ProviderAnalytics = lazy(() =>
  import(
    /* webpackChunkName: "providerAnalytics" */ "../components/providerAnalytics/ProviderAnalytics.jsx"
  )
);

const DashboardOperacional = lazy(() =>
  import(
    /* webpackChunkName: "dashboardOperacional" */ "../components/dashboard-operacional/DashboardOperacional.jsx"
  )
);

const ZoneMismatch = lazy(() =>
  import(
    /* webpackChunkName: "ZoneMismatch" */ "../components/driverTiming/ZoneMismatch"
  )
);

const OrderTrend = lazy(() =>
  import(
    /* webpackChunkName: "orderTrend" */ "../components/orderTrend/OrderTrend"
  )
);

const QuoteTrend = lazy(() =>
  import(/* webpackChunkName: "QuoteTrend" */ "../components/quoteTrend/QuoteTrend")
);

const LostOrderTrend = lazy(() =>
  import(
    /* webpackChunkName: "LostOrderTrend" */ "../components/lostorderTrend/LostOrderTrend"
  )
);

const Refunds = lazy(() =>
  import(/* webpackChunkName: "Refunds" */ "../components/refund/Refund")
);
const RefundsNew = lazy(() =>
  import(/* webpackChunkName: "RefundsNew" */ "../components/refund/Refund-new.jsx")
);

const Batches = lazy(() =>
  import(
    /* webpackChunkName: "Batches" */ "../components/batches/Batches"
  )
);
const SmartBatchesConfig = lazy(() =>
  import(
    /* webpackChunkName: "SmartBatchesConfig" */ "../components/batches/SmartBatchesConfig"
  )
);
const AutoassignConfig = lazy(() =>
  import(
    /* webpackChunkName: "AutoassignConfig" */ "../components/autoassign/AutoassignConfig"
  )
);
const LiveBatchesMap = lazy(() =>
  import(
    /* webpackChunkName: "LiveBatchesMap" */ "../components/batches/LiveBatchesMap"
  )
);
const DemandForecast = lazy(() =>
  import(
    /* webpackChunkName: "DemandForecast" */ "../components/demandForecast/DemandForecast"
  )
);

export const routes = [
  // ── Operaciones ──────────────────────────────────────
  {
    to: "/map-screem",
    path: "map-screem",
    Component: MapScreem,
    name: "Main - Map",
    icon: "fa-solid fa-house",
    omit: false,
    section: "Operaciones",
  },
  {
    to: "/orders",
    path: "orders",
    Component: Orders,
    name: "Orders",
    icon: "fa-solid fa-arrow-down-short-wide",
    omit: false,
    section: "Operaciones",
  },
  {
    to: "/orders-legacy",
    path: "orders-legacy",
    Component: OrdersLegacy,
    name: "Orders Legacy",
    icon: "fa-solid fa-clock-rotate-left",
    omit: false,
    section: "Operaciones",
  },
  {
    to: "/operation-map",
    path: "operation-map",
    Component: OperationMap,
    name: "Nueva Operacion",
    icon: "fa-solid fa-location-dot",
    omit: false,
    section: "Operaciones",
  },
  {
    to: "/demand-forecast",
    path: "demand-forecast",
    Component: DemandForecast,
    name: "Predicción Demanda",
    icon: "fa-solid fa-fire",
    omit: false,
    section: "Operaciones",
  },
  {
    to: "/panel-lite",
    path: "panel-lite",
    Component: PanelLite,
    name: "Panel Lite",
    icon: "fa-solid fa-clock-rotate-left",
    omit: false,
    section: "Operaciones",
  },
  {
    to: "/panel-lite-legacy",
    path: "panel-lite-legacy",
    Component: PanelLiteLegacy,
    name: "Panel Lite Legacy",
    icon: "fa-solid fa-clock-rotate-left",
    omit: false,
    section: "Operaciones",
  },
  {
    to: "/panel-general",
    path: "panel-general",
    Component: PanelGeneral,
    name: "Panel General",
    icon: "fa-solid fa-table-columns",
    omit: false,
    section: "Operaciones",
  },
  {
    to: "/dashboard-supervisor",
    path: "dashboard-supervisor",
    Component: DashboardSupervisor,
    name: "Dashboard Supervisor",
    icon: "fa-solid fa-chart-line",
    omit: false,
    section: "Métricas",
  },
  {
    to: "/payment-reports",
    path: "payment-reports",
    Component: PaymentReports,
    name: "Reportes de pagos",
    icon: "fa-solid fa-money-check-dollar",
    omit: false,
    section: "Métricas",
  },
  {
    to: "/analityc",
    path: "analityc",
    Component: Analityc,
    name: "Analityc",
    icon: "fa-solid fa-chart-line",
    omit: false,
    section: "Operaciones",
  },
  {
    to: "/reclamo",
    path: "reclamo",
    Component: Reclamo,
    name: "Reclamos",
    icon: "fa-solid fa-head-side-cough",
    omit: false,
    section: "Operaciones",
  },
  {
    to: "/notifications",
    path: "notifications",
    Component: Notification,
    name: "Notificaciones",
    icon: "fa-solid fa-bell",
    omit: false,
    section: "Operaciones",
  },
  // ── Timings ───────────────────────────────────────────
  {
    to: "/timigs",
    path: "timigs",
    Component: Timings,
    name: "Timig",
    icon: "fa-solid fa-clock",
    omit: false,
    section: "Timings",
  },
  {
    to: "/driver-timigs",
    path: "driver-timigs",
    Component: ScreemDriverTiming,
    name: "Driver-Timig",
    icon: "fa-solid fa-users",
    omit: false,
    section: "Timings",
  },
  {
    to: "/zone-mismatch",
    path: "zone-mismatch",
    Component: ZoneMismatch,
    name: "Zone Mismatch",
    icon: "fa-solid fa-triangle-exclamation",
    omit: false,
    section: "Timings",
  },
  {
    to: "/auto-timings",
    path: "auto-timings",
    Component: AutoTimings,
    name: "Auto Timings",
    icon: "fa-solid fa-clock-rotate-left",
    omit: false,
    section: "Timings",
  },
  {
    to: "/calendar",
    path: "calendar",
    Component: CalendarTiming,
    name: "Calendar",
    icon: "fa-solid fa-calendar-days",
    omit: false,
    section: "Timings",
  },
  {
    to: "/turnsWeek",
    path: "turnsWeek",
    Component: TurnWeekPage,
    name: "Turns Week",
    icon: "fa-solid fa-calendar-week",
    omit: false,
    section: "Timings",
  },
  {
    to: "/ordersByHour",
    path: "ordersByHour",
    Component: OrdersByHours,
    name: "Order by Hours",
    icon: "fa-solid fa-gear",
    omit: false,
    section: "Timings",
  },
  {
    to: "/ordersByHourUpload",
    path: "ordersByHourUpload",
    Component: OrdersByHoursUpload,
    name: "Order by Hours Excel",
    icon: "fa-solid fa-file-excel",
    omit: false,
    section: "Timings",
  },
  {
    to: "/automations",
    path: "automations",
    Component: Automations,
    name: "Automatizaciones",
    icon: "fa-solid fa-robot",
    omit: false,
    section: "Timings",
  },
  {
    to: "/dashboard-operacional",
    path: "dashboard-operacional",
    Component: DashboardOperacional,
    name: "Dashboard Operacional",
    icon: "fa-solid fa-chart-bar",
    omit: false,
    section: "Métricas",
  },
  {
    to: "/timing-kpi",
    path: "timing-kpi",
    Component: TimingKPIPage,
    name: "Drivers Tiempos",
    icon: "fa-solid fa-stopwatch",
    omit: false,
    section: "Métricas",
  },
  {
    to: "/driver-orders-hour-zone",
    path: "driver-orders-hour-zone",
    Component: DriverOrdersByHourZonePage,
    name: "Pedidos Driver x Hora",
    icon: "fa-solid fa-map-location-dot",
    omit: false,
    section: "Métricas",
  },
  {
    to: "/Provider-Analytics",
    path: "Provider-Analytics",
    Component: ProviderAnalytics,
    name: "Provider Analytics",
    icon: "fa-solid fa-chart-pie",
    omit: false,
    section: "Métricas",
  },
  {
    to: "/order-trend",
    path: "order-trend",
    Component: OrderTrend,
    name: "Tendencia Pedidos",
    icon: "fa-solid fa-chart-line",
    omit: false,
    section: "Métricas",
  },
  {
    to: "/quote-trend",
    path: "quote-trend",
    Component: QuoteTrend,
    name: "Tendencias de Cotizaciones",
    icon: "fa-solid fa-chart-line",
    omit: false,
    section: "Métricas",
  },
  {
    to: "/lost-order-trend",
    path: "lost-order-trend",
    Component: LostOrderTrend,
    name: "Órdenes Perdidas",
    icon: "fa-solid fa-triangle-exclamation",
    omit: false,
    section: "Métricas",
  },

  {
    to: "/timingByDate:day",
    path: "timingByDate/:day",
    Component: TimingByDate,
    name: "Turnos por dia",
    icon: "fa-solid fa-calendar-days",
    omit: true,
    section: "Timings",
  },
  // ── Batches ───────────────────────────────────────────
  {
    to: "/batches",
    path: "batches",
    Component: Batches,
    name: "Lista de Batches",
    icon: "fa-solid fa-layer-group",
    omit: false,
    section: "Batches",
  },
  {
    to: "/smart-batches",
    path: "smart-batches",
    Component: SmartBatchesConfig,
    name: "Configurar Batch",
    icon: "fa-solid fa-gears",
    omit: false,
    section: "Batches",
  },
  {
    to: "/autoassign-config",
    path: "autoassign-config",
    Component: AutoassignConfig,
    name: "Configurar Autoasignado",
    icon: "fa-solid fa-robot",
    omit: false,
    section: "Batches",
  },
  {
    to: "/live-batches",
    path: "live-batches",
    Component: LiveBatchesMap,
    name: "Batches en Vivo",
    icon: "fa-solid fa-map-location-dot",
    omit: false,
    section: "Batches",
  },
  // ── Drivers ───────────────────────────────────────────
  {
    to: "/drivers",
    path: "drivers",
    Component: Drivers,
    name: "Drivers",
    icon: "fa-solid fa-motorcycle",
    omit: false,
    section: "Drivers",
  },
  {
    to: "/drivers-wallet",
    path: "driversWallet",
    Component: DriversWallet,
    name: "Drivers Wallet",
    icon: "fa-solid fa-credit-card-alt",
    omit: false,
    section: "Drivers",
  },
  {
    to: "/botDrivers",
    path: "botDrivers",
    Component: BotDrivers,
    name: "Bot Drivers",
    icon: "fa-solid fa-robot",
    omit: false,
    section: "Drivers",
  },
  {
    to: "/driver-order-history",
    path: "driver-order-history",
    Component: DriverOrderHistory,
    name: "Driver Order History",
    icon: "fa-solid fa-motorcycle",
    omit: false,
    section: "Drivers",
  },
  // ── Merchants ─────────────────────────────────────────
  {
    to: "/merchants",
    path: "merchants",
    Component: Merchant,
    name: "Merchant",
    icon: "fa-solid fa-store",
    omit: false,
    section: "Merchants",
  },
  {
    to: "/merchants-app",
    path: "merchants-app",
    Component: MerchantsHomeApp,
    name: "Merchants Home App",
    icon: "fa-solid fa-store",
    omit: false,
    section: "Merchants",
  },
  {
    to: "/merchantLocation",
    path: "/merchantLocation",
    Component: MerchantLocation,
    name: "Merchant Location",
    icon: "fa-solid fa-map-location-dot",
    omit: false,
    section: "Merchants",
  },
  {
    to: "/merchantConfig",
    path: "/merchantConfig",
    Component: MerchantConfig,
    name: "Merchant Config",
    icon: "fa-solid fa-gears",
    omit: false,
    section: "Merchants",
  },
  {
    to: "/banner",
    path: "banner",
    Component: Banner,
    name: "Banners",
    icon: "fa fa-note-sticky",
    omit: false,
    section: "Merchants",
  },
  {
    to: "/merchantDetails/:id",
    path: "/merchantDetails/:id",
    Component: MerchantDetails,
    name: "MerchantDetails",
    icon: "fa-solid fa-store",
    omit: true,
    section: "Merchants",
  },
  {
    to: "/item/:id/:productId/:requiredSku?",
    path: "/item/:id/:productId/:requiredSku?",
    Component: Item,
    name: "MerchantItem",
    icon: "fa-solid fa-store",
    omit: true,
    section: "Merchants",
  },
  {
    to: "/openingHours/:id",
    path: "/openingHours/:id",
    Component: OpeningHours,
    name: "MerchantItem",
    icon: "fa-solid fa-store",
    omit: true,
    section: "Merchants",
  },
  {
    to: "/merchantVehicleType/:id",
    path: "/merchantVehicleType/:id",
    Component: MerchantVehicleType,
    name: "MerchantVehicleType",
    icon: "fa-solid fa-store",
    omit: true,
    section: "Merchants",
  },
  // ── Cobertura ─────────────────────────────────────────
  {
    to: "/zone",
    path: "zone",
    Component: Zone,
    name: "Zone",
    icon: "fa-solid fa-map",
    omit: false,
    section: "Cobertura",
  },
  {
    to: "/coverage",
    path: "coverage",
    Component: Coverage,
    name: "Coverage",
    icon: "fa fa-draw-polygon",
    omit: false,
    section: "Cobertura",
  },
  {
    to: "/coverage-status",
    path: "coverage-status",
    Component: CoverageStatus,
    name: "Coverage Status",
    icon: "fa-solid fa-toggle-on",
    omit: false,
    section: "Cobertura",
  },
  {
    to: "/coverage-map",
    path: "coverage-map",
    Component: CoverageMap,
    name: "Coverage Map",
    icon: "fa-solid fa-map-location-dot",
    omit: false,
    section: "Cobertura",
  },
  {
    to: "/heat-map",
    path: "heat-map",
    Component: HeatMap,
    name: "HeatMap Orders",
    icon: "fa-solid fa-map",
    omit: false,
    section: "Cobertura",
  },
  {
    to: "/heatmap-quote",
    path: "heatmap-quote",
    Component: HeatMapQuote,
    name: "HeatMap Quotes",
    icon: "fa-solid fa-map",
    omit: false,
    section: "Cobertura",
  },
  {
    to: "/map-zipcode",
    path: "map-zipcode",
    Component: MapZipCode,
    name: "Map ZipCode",
    icon: "fa-solid fa-draw-polygon",
    omit: false,
    section: "Cobertura",
  },
  {
    to: "/map-zipcode-edit",
    path: "map-zipcode-edit",
    Component: MapZipCodeEdit,
    name: "Editar Map ZipCode",
    icon: "fa-solid fa-edit",
    omit: false,
    section: "Cobertura",
  },
  // ── Finanzas ──────────────────────────────────────────
  {
    to: "/refunds",
    path: "refunds",
    Component: Refunds,
    name: "Refunds",
    icon: "fa-solid fa-rotate-left",
    omit: false,
    section: "Finanzas",
  },
  {
    to: "/refunds-new",
    path: "refunds-new",
    Component: RefundsNew,
    name: "Refunds Excel",
    icon: "fa-solid fa-table",
    omit: false,
    section: "Finanzas",
  },
  {
    to: "/fares",
    path: "fares",
    Component: Fare,
    name: "Fare structure",
    icon: "fa-solid fa-list-ul",
    omit: false,
    section: "Finanzas",
  },
  {
    to: "/provider-fares",
    path: "provider-fares",
    Component: ProviderFare,
    name: "Provider Fares",
    icon: "fa-solid fa-file-invoice-dollar",
    omit: false,
    section: "Finanzas",
  },
  {
    to: "/report",
    path: "report",
    Component: Report,
    name: "Executive-report",
    icon: "fa-solid fa-chart-bar",
    omit: false,
    section: "Finanzas",
  },
  {
    to: "/coupons",
    path: "coupons",
    Component: Coupons,
    name: "Coupons",
    icon: "fa-solid fa-receipt",
    omit: false,
    section: "Finanzas",
  },
  {
    to: "/coupons-users",
    path: "coupons-users",
    Component: CouponsUser,
    name: "Coupons Users",
    icon: "fa-solid fa-receipt",
    omit: false,
    section: "Finanzas",
  },
  {
    to: "/control-cost/",
    path: "/control-cost/",
    Component: ControlCost,
    name: "Control Cost",
    icon: "fa-solid fa-money-bill",
    omit: false,
    section: "Finanzas",
  },
  {
    to: "/offerts",
    path: "offerts",
    Component: Offer,
    name: "Offerts",
    icon: "fa-solid fa-tag",
    omit: false,
    section: "Finanzas",
  },
  {
    to: "/productOffer",
    path: "productOffer",
    Component: ProductOffers,
    name: "Product Offers",
    icon: "fa-solid fa-percent",
    omit: false,
    section: "Finanzas",
  },
  {
    to: "/fare-detail/:id",
    path: "fare-detail",
    Component: FareDetail,
    name: "Fare details",
    icon: "fa-solid fa-list-ul",
    omit: true,
    section: "Finanzas",
  },
  {
    to: "/provider-fare-detail/:id",
    path: "provider-fare-detail/:id",
    Component: ProviderFareDetail,
    name: "Provider Fare Details",
    icon: "fa-solid fa-file-invoice-dollar",
    omit: true,
    section: "Finanzas",
  },
  // ── Clientes ──────────────────────────────────────────
  {
    to: "/customer",
    path: "customer",
    Component: QuickDrop,
    name: "Customers",
    icon: "fa-solid fa-users",
    omit: false,
    section: "Clientes",
  },
  {
    to: "/feedback",
    path: "feedback",
    Component: FeedBack,
    name: "Feedback",
    icon: "fa-solid fa-bug",
    omit: false,
    section: "Clientes",
  },
  {
    to: "/upload-image",
    path: "upload-image",
    Component: UploadImage,
    name: "Upload Image",
    icon: "fa-solid fa-image",
    omit: false,
    section: "Clientes",
  },
];
